import React from 'react';
import { useNavigate } from 'react-router-dom';
import MonthlyDashboard from './MonthlyDashboard';
import './Stats.css';

const Stats: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="stats-container">
      <div className="stats-header">
        <div className="stats-header-top">
          <h1>Statistics Dashboard</h1>
          <div className="stats-header-buttons">
            <button
              className="stripe-button"
              onClick={() => navigate('/stripe')}
            >
              Stripe
            </button>
          </div>
        </div>
      </div>
      <MonthlyDashboard />
    </div>
  );
};

export default Stats;
